import { SearchDatesOptions } from 'KM/common-models';
//import { HotelViewModel } from 'KM/HotelViewModel';
//import { CombinationViewModel } from 'KM/CombinationViewModel';
//import { runGoogleAdwords, updateTrivagoTracking } from 'Utils/global';
//import { GetBreakpointWidth } from 'Utils/globals-bp';
//import { updateQueryStringWithoutHistory } from 'Utils/global';
//import { HotelSortingField, SearchResultBannerViewModel } from 'KM/common-models';
//import {  hideSection } from 'Utils/section';
//import 'Vendors/daterangepicker/knockout.daterangepicker';
//import 'Vendors/groupedSelect/knockout.groupedSelect';
//import { updateUI } from 'SrcJS/script--updateUI';


function datepickerHelpText(input) {
    setTimeout(function () {
        if ($('.ui-datepicker :last-child').is('table')) {
            var flgHelpText = searchViewModel.CalendarSettings() ? searchViewModel.CalendarSettings().Visible_HelpText() : !searchViewModel.HotelOnly();
            if (flgHelpText) {
                $('.ui-datepicker')
                    .append('<div class="greenmark-info"><span></span><div>' + AppData.Translations["calendar_helptext_green"] + '</div></div>')
                    .append('<div class="bluemark-info"><span></span><div>' + AppData.Translations["calendar_helptext_blue"] + '</div></div>');
            }
            //$('.ui-datepicker')
            //    .append('<div class="ui-datepicker-buttonpane ui-widget-content"><button class="ui-datepicker-current ui-state-default ui-corner-all" onClick="searchViewModel.ClearDates()">' + AppData.Translations["calendar_nodates"] + '</button></div>');
            var btn = $('<div class="ui-datepicker-buttonpane ui-widget-content"><button class="ui-datepicker-current ui-state-default ui-corner-all">' + AppData.Translations["calendar_nodates"] + '</button></div>');
            btn.unbind("click").bind("click", function () {
                searchViewModel.ClearDates();
                $.datepicker._clearDate(input);
            });
            btn.appendTo($('.ui-datepicker'));
        }
    }, 50);
};

function addDays(date, days) {
    var result = new Date(date);
    result.setDate(date.getDate() + days);
    return result;
};

function get_fromDatepickerOptions(searchViewModel) {
    return fromDatepickerOptions = {
        showOn: "both",
        buttonImage: AssetImgUrl("kalender.png"),
        buttonImageOnly: true,
        isRTL: false,
        showWeek: true,
        defaultDate: "+1w",
        minDate: addDays(new Date(), SearchDatesOptions.DepartureDay.Min),
        changeMonth: false,
        showOtherMonths: true,
        selectOtherMonths: false,
        numberOfMonths: 1,
        beforeShowDay: searchViewModel.CalendarSettings().HighlightCalendarDatesFrom,
        onClose: function (selectedDate, inst) {


            var curDate = $(this).datepicker('getDate');
            if (curDate) {
                var minDate = new Date(curDate);
                var maxDate = new Date(curDate);
                //var selectDate = new Date(curDate);
                var selectDate = null;
                minDate.setDate(curDate.getDate() + SearchDatesOptions.TravelDays.Min);
                //selectDate.setDate(curDate.getDate() + 7);
                //maxDate.setDate(curDate.getDate() + 20);
                //maxDate.setDate(curDate.getDate() + 7);
                /*2017-03-21 If ReturnDate is more 21days Then set current selected date pluss 2days */
                maxDate.setDate(curDate.getDate() + SearchDatesOptions.TravelDays.Max);

                //$(".toDatepicker").datepicker("option", "minDate", minDate);

                /*2016-07-08 Update ReturnDate if current selected date less minDate */
                var toDate = $(".toDatepicker").datepicker("getDate");
                $(".toDatepicker").datepicker("option", "minDate", minDate);
                if (toDate && (toDate < minDate)) {
                    //$(".toDatepicker").datepicker("setDate", minDate);
                    //searchViewModel.ReturnDate(minDate);
                    selectDate = minDate;
                }
                /*2016-09-26 Update ReturnDate if current selected date more maxDate */
                if (toDate && (toDate > maxDate)) {
                    //selectDate = maxDate;
                    /*2017-03-21 If ReturnDate is more 21days Then set current selected date pluss 2days */
                    selectDate = new Date(curDate);
                    selectDate.setDate(curDate.getDate() + 2);
                }
                if (selectDate != null) {
                    $(".toDatepicker").datepicker("setDate", selectDate);
                    searchViewModel.ReturnDate(selectDate);
                }

                /* Do not select return date automatically
                $(".toDatepicker").datepicker("setDate", selectDate);
                searchViewModel.ReturnDate(selectDate);
                */

                //inst.lastVal is always equals with selectedDate
                var oldValue = $(inst.input).attr('data-value-old');
                if (selectedDate && selectedDate != "" && oldValue !== selectedDate) {
                    var $holder = $(this).parents('.search');
                    if ($holder && $holder.length > 0) {
                        var $toDatepicker = $holder.find('.toDatepicker');
                        if ($toDatepicker && $toDatepicker.length > 0) {
                            setTimeout(function () {
                                $toDatepicker.datepicker('show');
                            }, 50);
                        }
                    }
                }
            }


        },
        //beforeShow: datepickerHelpText,
        beforeShow: function (input) {
            $input = $(input);
            $input.attr('data-value-old', $input.val());
            datepickerHelpText(input);
        },
        onChangeMonthYear: datepickerHelpText,
    };
}

function get_toDatepickerOptions(searchViewModel) {
    return toDatepickerOptions = {
        showOn: "both",
        buttonImage: AssetImgUrl("kalender.png"),
        buttonImageOnly: true,
        isRTL: false,
        showWeek: true,
        defaultDate: "+1w",
        changeMonth: false,
        showOtherMonths: true,
        selectOtherMonths: false,
        numberOfMonths: 1,
        beforeShowDay: searchViewModel.CalendarSettings().HighlightCalendarDatesTo,
        onClose: function (selectedDate) {
            //$(".fromDatepicker").datepicker("option", "maxDate", selectedDate);
        },
        beforeShow: datepickerHelpText,
        onChangeMonthYear: datepickerHelpText,
    };
}

export { datepickerHelpText, addDays, get_fromDatepickerOptions, get_toDatepickerOptions }